'use strict';

HIconPickerComponent.$inject = [`$scope`, `useIconPicker`];

function HIconPickerComponent($scope, useIconPicker) {
    const self = this;
    self.iconFactory = useIconPicker($scope);

    self.assignHandlers = (element) => {
        element[0].querySelectorAll('.icon-btn').forEach((button) => {
            button.addEventListener('click', function (event) {
                element.find('.icon-btn.selected').removeClass('selected hui-accent');
                self.ngModel = $(button).data(`icon`);
                $(button).addClass('selected hui-accent');
                self.data.ngModel = self.ngModel;
            });
        });
    };

    self.$onInit = () => {
        self.data = {
            filteredIcons: self.iconFactory.state.filteredIcons,
            ngModel: self.ngModel,
        };

        self.iconFactory.init()
            .then(() => {
                self.data.filteredIcons = self.iconFactory.state.filteredIcons;
                self.viewTrigger = !self.viewTrigger;
            });
    };

    self.$onDestroy = () => {
        self.iconFactory.resetIcons();
    };

    self.search = () => {
        self.iconFactory.search(self.searchTerm);
        self.viewTrigger = !self.viewTrigger;
        self.data.filteredIcons = self.iconFactory.state.filteredIcons;
    };
}

angular
    .module("harriApp")
    .component("hIconPicker", {
        controller: HIconPickerComponent,
        bindings: {
            ngModel: '=',
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-icon-picker/h-icon-picker.component.ng.html'
    });


